import type { ReactNode } from "react";

const ITEMS: { q: string; a: ReactNode }[] = [
  {
    q: "Which data sources can a dataset use?",
    a: (
      <>
        <p>
          <strong>Papers:</strong> more than 3.4 million: PubMed Central full text, PubMed abstracts, bioRxiv and medRxiv
          preprints, and arXiv.
        </p>
        <p>
          <strong>Other records:</strong> trial registries (ClinicalTrials.gov, including posted results, plus EU, ISRCTN,
          Japanese and Chinese registries); regulatory documents (FDA, EMA and PMDA labels and reviews); drug-discovery
          patents; SEC filings; NCBI GEO datasets; and UniProt, PDB and ChEMBL protein entries.
        </p>
      </>
    ),
  },
  {
    q: "How does it choose which sources to search?",
    a: (
      <p>
        The builder picks the sources your request calls for, papers included, and you can turn any of them on or off
        before anything is read. Naming one (for example &ldquo;FDA labels&rdquo;, &ldquo;patents&rdquo; or
        &ldquo;registered trials&rdquo;) makes it search that source first and read more of its records.
      </p>
    ),
  },
  {
    q: "Where does each value come from?",
    a: (
      <p>
        Every value is tied to the exact words of its source. Click a cell to see the passage with those words
        highlighted. Calculated values show their arithmetic, and values grouped under one label keep their original
        wording.
      </p>
    ),
  },
  {
    q: "How long does a build take?",
    a: <p>About two minutes. Rows appear as they are found. More rows and Broaden search keep reading.</p>,
  },
  {
    q: "Can I cite a dataset in a paper?",
    a: (
      <p>
        When a build finishes, Paperclip writes a methods section describing how the dataset was made, which sources it
        drew on and how values were checked. Open it with View Methods. Export CSV gives each value with its quote and
        source.
      </p>
    ),
  },
];

/** Questions people ask about datasets, on the empty page. */
export const DatasetsFaq = () => (
  <section className="mt-12 max-w-[760px]" aria-label="Frequently asked questions">
    <h2 className="font-ui text-2xs uppercase tracking-wider text-zinc-400">FAQ</h2>
    <div className="mt-2 divide-y divide-zinc-200 border-y border-zinc-200">
      {ITEMS.map((item) => (
        <details key={item.q} className="group py-2.5">
          <summary className="cursor-pointer list-none text-[14px] text-zinc-900 marker:hidden">
            <span className="mr-2 inline-block w-3 text-zinc-400 transition-transform group-open:rotate-90">›</span>
            {item.q}
          </summary>
          <div className="space-y-2 pb-1 pl-5 pt-1.5 text-[13px] leading-relaxed text-zinc-600">{item.a}</div>
        </details>
      ))}
    </div>
  </section>
);
